module.exports = __webpack_public_path__ + "fonts/78a5dfe781346d907cba0afd6faceedb.svg";